import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, computed } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';

type theme = 'light' | 'dark';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  private _theme = new BehaviorSubject<theme>(this.getLocalStorageTheme());

  #theme = toSignal(this._theme);
  public themeIcon = computed(() => this.#theme() === 'dark' ? 'pi pi-moon' : 'pi pi-sun');

  constructor(@Inject(DOCUMENT) private document: Document) { }

  initializeTheme() {
    let theme = this.getLocalStorageTheme();
    this.switchTheme(theme);
  }

  getLocalStorageTheme(): theme {    
    return (localStorage.getItem('theme') as theme) || 'dark';
  }

  flipTheme() {
    let theme: theme = this.#theme() === 'light' ? 'dark' : 'light';
    this.switchTheme(theme);
  }

  switchTheme(theme: theme) {
    let themeLink = this.document.getElementById('app-theme') as HTMLLinkElement;

    if (themeLink) {
      themeLink.href = theme + '.css';
      localStorage.setItem('theme', theme);
      // Gancho de CSS por tema (logo da marca em .brand-logo, splash etc.);
      // o index.html também seta este atributo ANTES do boot p/ evitar flash.
      this.document.documentElement.setAttribute('data-theme', theme);
      this._theme.next(theme);
    }
  }
}
